import { Injectable, signal } from '@angular/core';
import { SearchBannerFragment } from './search-banner.query.generated';

@Injectable({
  providedIn: 'root',
})
export class SearchBannerService {
  constructor() {}

  private bannerSignal = signal<SearchBannerFragment | null>(null);

  setBanner(banner: SearchBannerFragment) {
    this.bannerSignal.set(banner);
  }

  get banner() {
    return this.bannerSignal;
  }
}
